import { showStorageBlocked, storageBlocked } from '@core/storage-blocked/storage-blocked';

// The app reads localStorage as soon as it loads (sign-in token, settings), so check before loading it.
if (storageBlocked()) {
  showStorageBlocked(document);
} else {
  void import('./bootstrap');
}
